export interface ParsedContent {
  text: string;
  imagesCount: number;
  filesCount: number;
}

export const postContentParser = (contentStr: string): ParsedContent => {
  let text = '';
  let imagesCount = 0;
  let filesCount = 0;

  if (!contentStr) {
    return { text, imagesCount, filesCount };
  }

  try {
    const parsed = JSON.parse(contentStr);

    // 1. Slate format text extraction
    if (parsed && Array.isArray(parsed.value)) {
      const traverse = (node: any): string => {
        if (typeof node.text === 'string') {
          return node.text;
        }
        if (Array.isArray(node.children)) {
          return node.children.map(traverse).join('');
        }
        return '';
      };

      text = parsed.value
        .map((block: any) => traverse(block))
        .filter((val: string) => val.trim().length > 0)
        .join('\n');
    } else if (parsed && Array.isArray(parsed.blocks)) {
      text = parsed.blocks
        .map((block: any) => block.text || '')
        .filter((val: string) => val.trim().length > 0)
        .join('\n');
    }

    if (parsed && parsed.context?.entities && Array.isArray(parsed.value)) {
      const referencedEntityIds = new Set<string>(
        parsed.value
          .filter((block: any) => block.type === 'fileBlock' && block.entity)
          .map((block: any) => block.entity)
      );

      referencedEntityIds.forEach((entityId) => {
        const entity = parsed.context.entities[entityId];
        if (entity && entity.type === 'file') {
          const fileType = entity.data?.type || entity.file?.type || '';
          if (fileType.startsWith('image/')) {
            imagesCount++;
          } else {
            filesCount++;
          }
        }
      });
    }
    // 2. Draft.js format entities extraction
    if (parsed && parsed.entityMap && typeof parsed.entityMap === 'object') {
      Object.values(parsed.entityMap).forEach((entity: any) => {
        const entityType = (entity.type || '').toUpperCase();
        if (entityType.includes('IMAGE')) {
          imagesCount++;
        } else if (
          entityType.includes('FILE') ||
          entityType.includes('DOCUMENT')
        ) {
          filesCount++;
        }
      });
    }
  } catch (e) {
    // If parsing fails, it's probably raw text content
    text = contentStr;
  }

  return { text, imagesCount, filesCount };
};
